import { Injector } from '@angular/core';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';
import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  customRepeaterFieldParseIntoSettingsFormModel,
  customRepeaterFieldUpdateFromSettingsFormModel,
  defaultCustomRepeaterConfigFormModel,
} from '../custom-repeater-field-type.configuration';
import { getDefaultBaseSettingsConfigFormly } from '../../form-fields-formly-settings/form-builder-default-settings-configuration-formly-fields.utils';
import { TConfigurationFormModelTypes } from '../../../../models/form-builder-types-configurations.model';

export class CustomRepeaterFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.settingsFormlyModel = defaultCustomRepeaterConfigFormModel;
    this.settingsFormlyForm = [
      ...getDefaultBaseSettingsConfigFormly(this.formBuilderService),
    ];
  }

  override parseFieldConfigIntoSettingsFormModel(): TConfigurationFormModelTypes {
    return customRepeaterFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(model: any) {
    return customRepeaterFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
